import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const headingSx = {
  fontFamily: "KIAbodyLatinbasic_Bold",
  textAlign: "center",
  fontSize: "clamp(24px, 4vw, 34px)",
  mb: 4,
  px: 2,
};

export function LovedByWorld({ heading, images }) {
  return (
    <Box sx={{ py: { xs: 4, md: 6 }, backgroundColor: "#f8f8f8" }}>
      <Typography sx={headingSx}>{heading}</Typography>
      <Container maxWidth="lg">
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={16}
          slidesPerView={1.1}
          breakpoints={{ 600: { slidesPerView: 2 }, 960: { slidesPerView: 3 } }}
          style={{ paddingBottom: 40 }}
        >
          {images.map((src) => (
            <SwiperSlide key={src}>
              <Box
                component="img"
                src={src}
                alt="Kia Sorento around the world"
                loading="lazy"
                decoding="async"
                sx={{ width: "100%", aspectRatio: "4 / 5", objectFit: "cover", display: "block" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  );
}

export function Awards({ heading, tabs }) {
  const [active, setActive] = useState(0);
  const current = tabs[active];

  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Typography sx={headingSx}>{heading}</Typography>
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flexWrap: "wrap", mb: 4 }}>
          {tabs.map((tab, i) => (
            <Box
              key={tab.label}
              component="button"
              onClick={() => setActive(i)}
              sx={{
                px: { xs: 2, sm: 3 },
                py: 1,
                cursor: "pointer",
                border: "1px solid #05141f",
                borderRadius: "20px",
                backgroundColor: i === active ? "#05141f" : "#fff",
                color: i === active ? "#fff" : "#05141f",
                fontFamily: "KIAbodyLatinbasic_Regular",
                fontSize: "14px",
                transition: "all 0.3s",
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        {/* Desktop: four award cards */}
        <Box
          sx={{
            display: { xs: "none", md: "grid" },
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 2,
          }}
        >
          {current.images.map((src) => (
            <Box
              key={src}
              component="img"
              src={src}
              alt={`Kia Sorento ${current.label} award`}
              loading="lazy"
              decoding="async"
              sx={{ width: "100%", height: "auto", display: "block" }}
            />
          ))}
        </Box>

        {/* Mobile: single combined image */}
        <Box
          component="img"
          src={current.mobileImage}
          alt={`Kia Sorento ${current.label} awards`}
          loading="lazy"
          decoding="async"
          sx={{ display: { xs: "block", md: "none" }, width: "100%", height: "auto" }}
        />
      </Container>
    </Box>
  );
}
